import React, { FC, useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { GREEN } from "../styles/constants";
import getUndef from "../../lib/get-undef";
import { Additions } from "../сard/ProductCard";

interface Props {
  data?: any;
  isModal?;
  checked?: any;
  setChecked?: any;
  newArr?: any;
  setAdditionsStatus: (value: Additions) => void;
}

const AMOUNT_LIMIT = 4;

const AdditiveConfiguration: FC<Props> = ({
  data,
  isModal,
  checked,
  setChecked,
  setAdditionsStatus,
}) => {
  const toppings = getUndef(() => data.shop.collections[0].products);

  let formattedToppings = toppings.map((i) => {
    return {
      id: i.variants[0].id,
      name: i.variants[0].product.name,
      price: i.variants[0].price,
      amount: 0,
    };
  });

  let combinedArr = [];

  formattedToppings.forEach((item) => {
    let isPushed = false;

    checked.forEach((checkedItem) => {
      if (item.id === checkedItem.id) {
        isPushed = true;
        combinedArr.push(checkedItem);
      }
    });

    if (!isPushed) combinedArr.push(item);
  });

  const [arrCount, setArrCount] = useState(combinedArr);
  const [amountCount, setAmountCount] = useState(0);

  useEffect(() => {
    const getAmountCount = () => {
      let newAmountCount = 0;
      combinedArr.forEach((item) => {
        newAmountCount += item.amount;
      });
      return newAmountCount;
    };

    setAmountCount(getAmountCount());

    const isEqualArrays = (a: any[], b: any[]) => {
      return JSON.stringify(combinedArr) === JSON.stringify(arrCount);
    };

    if (!isEqualArrays(arrCount, combinedArr)) {
      setArrCount(combinedArr);
    }
  }, [combinedArr]);

  useEffect(() => {
    switch (amountCount) {
      case 0:
        setAdditionsStatus(Additions.Empty);
        break;
      case AMOUNT_LIMIT:
        setAdditionsStatus(Additions.Full);
        break;
      default:
        setAdditionsStatus(Additions.PartiallyFilled);
        break;
    }
  }, [amountCount]);

  const handleChange = (arr) => {
    const result = arr.filter((item) => item.amount);
    setChecked(result);
  };

  const amountPlus = (id) => {
    let newArr = [...arrCount];

    newArr = newArr.map((i) => {
      if (i.id === id && amountCount < AMOUNT_LIMIT) {
        return { ...i, amount: i.amount + 1 };
      } else {
        return i;
      }
    });

    setArrCount(newArr);
    handleChange(newArr);
  };

  const amountMinus = (id) => {
    let newArr = [...arrCount];

    newArr = newArr.map((i) => {
      if (i.id === id && i.amount > 0) {
        return { ...i, amount: i.amount - 1 };
      } else {
        return i;
      }
    });

    setArrCount(newArr);
    handleChange(newArr);
  };

  return (
    <>
      {toppings.map((item, index) => {
        const { id, name, images, variants } = item;
        return (
          <Block key={id} isModal={isModal}>
            {images[0] && (
              <ImageWrraper>
                <input type="checkbox" id={name} name="option" />
                <img src={images[0].url} className="cover" />
              </ImageWrraper>
            )}
            <Info>
              <div>
                <UpperBlock>{`${variants[0].price}₽${
                  !!variants[0] &&
                  !!variants[0].weight &&
                  Number(variants[0].weight) > 0
                    ? ` ${variants[0].weight} гр.`
                    : ""
                }`}</UpperBlock>
                <Name>{name}</Name>
              </div>
              <Count>
                <ButtonMinus
                  onClick={() => amountMinus(variants[0].id)}
                  count={combinedArr[index].amount}
                  amountCount={amountCount}
                />
                <span>{combinedArr[index].amount}</span>
                <ButtonPlus
                  onClick={() => amountPlus(variants[0].id)}
                  count={combinedArr[index].amount}
                  amountCount={amountCount}
                />
              </Count>
            </Info>
          </Block>
        );
      })}
    </>
  );
};

interface ButtonProps {
  count: number;
  amountCount: number;
}

const ButtonMinus = styled.button<ButtonProps>`
  border: ${({ count }) =>
    count === 0 ? "1px solid #cbcbcb" : `1px solid ${GREEN}`};
  background: ${({ count }) => (count === 0 ? "#efefef" : "transparent")};
  border-radius: 5px;
  min-width: 25px;
  min-height: 25px;
  position: relative;
  cursor: pointer;

  &:before,
  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: block;
    width: 15px;
    height: 1px;
    background-color: ${({ count }) => (count === 0 ? "#cbcbcb" : GREEN)};
    margin: auto;
    content: "";
  }
`;

const ButtonPlus = styled.button<ButtonProps>`
  border: ${({ count, amountCount }) =>
    count === AMOUNT_LIMIT || amountCount === AMOUNT_LIMIT
      ? "1px solid #cbcbcb"
      : `1px solid ${GREEN}`};
  background: ${({ amountCount }) =>
    amountCount < AMOUNT_LIMIT ? "transparent" : "#efefef"};
  border-radius: 5px;
  min-width: 25px;
  min-height: 25px;
  position: relative;
  cursor: pointer;

  &:before,
  &:after {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    display: block;
    width: 15px;
    height: 1px;
    background-color: ${({ count, amountCount }) =>
      count === AMOUNT_LIMIT || amountCount === AMOUNT_LIMIT
        ? "#cbcbcb"
        : GREEN};
    margin: auto;
    content: "";
  }

  &:after {
    transform: rotate(90deg);
  }
`;

const Count = styled.div`
  display: flex;
  align-items: center;

  span {
    font-size: 22px;
    margin: 0 10px;
  }
`;

const Info = styled.div`
  display: flex;
  align-items: center;

  width: 100%;
  max-width: 350px;
  margin-right: 20px;
  justify-content: space-between;

  @media (max-width: 430px) {
    margin-right: 0;
  }
`;

const ImageWrraper = styled.div`
  margin-right: 10px;
  img {
    display: block;
    width: 60px;
    height: 60px;
    border-radius: 50px;
  }
`;

const UpperBlock = styled.p`
  font-size: 12px;
  color: #818181;
  margin-bottom: 0;
`;

interface propsBlock {
  isModal?;
}

const Block = styled.li<propsBlock>`
  display: inline-flex;
  min-height: 70px;
  align-items: center;
  padding-bottom: 10px;
  width: 100%;
  margin-right: 20px;
  ${({ isModal }) => (isModal ? InModal : InFullCard)}

  input {
    position: absolute;
    left: -9999px;
  }
`;

interface LabelProps {
  active?: boolean;
}

interface FilterWithProps {
  active?: boolean;
}

const Name = styled.p<FilterWithProps>`
  border-radius: 15px;
  display: flex;
  align-items: center;
  margin: 0 16px 16px 0;
  line-height: 1.1;
  min-width: 150px;

  @media (max-width: 430px) {
    min-width: 0;
  }

  @media screen and (min-width: 375.01px) and (max-width: 1000px) {
    font-size: 16px;
    line-height: 1.2;
  }
`;

const InModal = css`
  flex-basis: 100%;
  max-width: 100%;
  margin-right: 0;
`;

const InFullCard = css`
  @media (max-width: 850px) {
    flex-basis: calc(100% - 20px);
    max-width: calc(100% - 20px);
    margin-right: 20px;
  }
`;

export default AdditiveConfiguration;
